// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDatePicker-HeaderContainer_cls1__a5xot","cls2":"VeloDatePicker-HeaderContainer_cls2__2qfH1 VeloDatePicker-HeaderContainer_cls1__a5xot"};